import { render } from "./LaravelPagination.vue?vue&type=template&id=799192c4"
import script from "./LaravelPagination.vue?vue&type=script&lang=js"
export * from "./LaravelPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__